import Navbar from '../../components/layout/Navbar';
import VisualizacionMetricas from '../../components/sections/VisualizacionMetricas';
import Footer from '../../components/layout/Footer';

export default function AnalisisPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar activeSection="analisis" />

      <main className="pt-16">
        <VisualizacionMetricas />
      </main>

      <Footer />
    </div>
  );
}